import UIkit from 'uikit';
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

export default function () {
    let slides = {};
    let reviewsContainer = UIkit.util.$$('.tm-reviews');

    UIkit.util.each(reviewsContainer, (container) => {
        setTimeout(() => {
            let sliderEl = UIkit.util.$('.swiper', container);

            let sliderInstance = new Swiper(sliderEl, {
                speed: 400,
                slidesPerView: 1,
                spaceBetween: 10,
                loop: false,
                watchSlidesVisibility: true,
                simulateTouch: false,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    1400: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        allowTouchMove: false,
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: UIkit.util.$$('.swiper-button-next', container),
                    prevEl: UIkit.util.$$('.swiper-button-prev', container),
                },
                on: {
                    init: function () {
                        slides = this.slides;
                    },
                },
            });
        }, 1000);
    });
}



// WEBPACK FOOTER //
// ./scripts/tourism/reviews.js